import { useEffect, useState } from 'react';
import ModalPrebilling from '../ModalPrebilling';
import { prebillingAvailable } from '../../../services/suscription.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { ENABLE_PREBILLING_FOR_YEAR } from '../../../shared/constants/prices';
import { ArrowCounterClockwise } from '@phosphor-icons/react';
import usePurchases from '../../../hooks/usePurchases';

export const Prebilling = () => {
	const { tokenSession } = useSelector((state: RootState) => state.auth);
	const { userHasAnnualSubscription } = usePurchases();
	const [subscriptionAnnualId, setSubscriptionAnnualId] = useState<
		number | null
	>(null);
	const [showPrebillingModal, setShowPrebillingModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const onClosePrebillingModal = (isSuccess: boolean) => {
		if (isSuccess) {
			setSubscriptionAnnualId(null);
		}
	};

	const prebillingAvailableCheck = async () => {
		try {
			if (isLoading) return;
			setIsLoading(true);
			const response = await prebillingAvailable(tokenSession);
			const subscriptionsAnnual = response.annual;
			if (subscriptionsAnnual.length > 0) {
				const [subscriptionAnnual] = subscriptionsAnnual;
				if (
					!subscriptionAnnual.years_covered.includes(ENABLE_PREBILLING_FOR_YEAR)
				) {
					setSubscriptionAnnualId(subscriptionAnnual.id);
				}
			}
		} catch (error) {
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		prebillingAvailableCheck();
	}, [tokenSession]);

	if (!subscriptionAnnualId || userHasAnnualSubscription) return null;

	return (
		<div>
			<ModalPrebilling
				showModal={showPrebillingModal}
				setShowModal={setShowPrebillingModal}
				subscriptionId={subscriptionAnnualId}
				onClose={onClosePrebillingModal}
			/>
			<div
				onClick={() => setShowPrebillingModal(true)}
				className='flex text-sm md:text-base items-start p-3 md:p-4 rounded-xl gap-2 md:gap-4 border border-[#6BA233] bg-[#F7F8F4] w-full cursor-pointer'
			>
				<div className=''>
					<div
						className='flex flex-row items-center gap-2 p-2 rounded-lg relative'
						style={{ backgroundColor: '#E9F0E0' }}
					>
						<ArrowCounterClockwise
							weight='bold'
							size={24}
							className='text-[#6BA233]'
						/>
					</div>
				</div>
				<p className='sm:text-base lg:text-base !leading-tight'>
					<b>En el 2024 te suscribiste a nuestro plan de declaración anual.</b>{' '}
					Sin embargo, tu renovación aún no se ha generado. Por favor haz clic
					aquí para anticipar tu renovación y empezar a preparar tu declaración
					anual 2024.
				</p>
			</div>
		</div>
	);
};
